import { Component, type ReactNode } from 'react';
import { reportHealth } from '../data/monitoring';
export class ErrorBoundary extends Component<{children:ReactNode},{failed:boolean}> {
  state={failed:false};
  static getDerivedStateFromError(){return{failed:true};}
  componentDidCatch(){reportHealth({event:'crash',area:'app',code:'render'});}
  render(){return this.state.failed?<main className="center-screen"><section className="card recovery-card"><h1>Let’s reopen your journal</h1><p>Something interrupted this screen. Saved entries and drafts remain on this phone.</p><button className="primary" onClick={()=>window.location.reload()}>Reopen app</button></section></main>:this.props.children;}
}
